import api from "../api/axios"

export const getAccountingSummary = (from, to) =>
  api.get("/accounting/summary", { params: { from, to } }).then((r) => r.data)
